export default __webpack_public_path__ + "static/media/1873.bf3fac28.png";